import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';

@Injectable({
  providedIn: 'root'
})
export class CodeSession implements Session
{
    constructor() { }

    get(): string | SessionCode
    {
        try{
            const code = localStorage.getItem( SessionKey.CODE ) 

            if (!code) return SessionCode.MISSING_VALUE

            return code            
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set(code : string): SessionCode
    {
        if(!code) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.CODE, code ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.CODE ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

